module.exports = __webpack_public_path__ + "img/dep_menu@3x.9519cc3f.png";